export default {
  categorias: [],
  categoriasActivas: [],
  selectedCategoria: null,
  error: false,
  errorMessage: [],
}
